"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckoutPayloadFromShortenerId = void 0;
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../../API/BaseApi"));
var index_1 = require("../../Config/index");
var interfaces_1 = require("../common/interfaces");
var interfaces_2 = require("../pricingApi/interfaces");
function getCheckoutPayloadFromShortenerId(data, requestOptions) {
    if (requestOptions === void 0) { requestOptions = {
        timeout: interfaces_2.PRICING_TIMEOUT,
    }; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, response;
        return tslib_1.__generator(this, function (_a) {
            request = {
                payloadId: data.id,
                dataRequested: 'getShortenerPayload',
            };
            response = BaseApi_1.default.doPostRequestToChegg(index_1.commerceDataAggregatorUrl, request, null, requestOptions.timeout);
            return [2 /*return*/, decoratePromise(response)];
        });
    });
}
exports.getCheckoutPayloadFromShortenerId = getCheckoutPayloadFromShortenerId;
function decoratePromise(promise) {
    return promise
        .then(function (resp) {
        var shortener = resp.data.shortener;
        var data = shortener.data, message = shortener.message, error = shortener.error;
        if (!error && !message && data) {
            return {
                success: true,
                data: {
                    payload: data.payload,
                },
                errors: null,
            };
        }
        else {
            return {
                success: false,
                data: null,
                errors: [
                    {
                        message: message,
                        code: error,
                        type: interfaces_1.ErrorType.SERVER,
                    },
                ],
            };
        }
    })
        .catch(function (error) { return JSON.parse(error.message); });
}
var checkoutUrlBuilderApi = {
    getCheckoutPayloadFromShortenerId: getCheckoutPayloadFromShortenerId,
};
exports.default = checkoutUrlBuilderApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/checkoutUrlBuilderApi/index.js
// module id = 3401
// module chunks = 11